import { IconProps } from '../ui/Icon/types';
import Icon from '../ui/Icon';

export default function IconWarning(props: IconProps) {
  return (
    <Icon viewBox="0 0 32 32" {...props}>
      <path
        d="M15.37 8.334l10.477 18.101h-20.953l10.477-18.101zM15.37 2.783l-15.304 26.435h30.609l-15.304-26.435zM16.761 22.261h-2.783v2.783h2.783v-2.783zM16.761 13.913h-2.783v5.565h2.783v-5.565z"
        fill="currentColor"
      />
    </Icon>
  );
}
